import { CreateUsername } from '@/modules/auth/components/CreateUsername';
import { ForgotPassword } from '@modules/auth/components/ForgotPassword';
import { AuthLayout } from '@modules/auth/components/layouts/AuthLayout';
import { LogIn } from '@modules/auth/components/LogIn';
import { ResetPassword } from '@modules/auth/components/ResetPassword/ResetPassword';
import { SignUp } from '@modules/auth/components/SignUp';
import { Verify } from '@modules/auth/components/Verify';

import type { AppRouteObject } from '@/routes';

export const routes: AppRouteObject[] = [
  {
    path: 'auth',
    element: <AuthLayout />,
    children: [
      {
        path: 'sign-up',
        element: <SignUp />,
        pageMeta: {
          title: 'Sign up',
        },
      },
      {
        path: 'login',
        element: <LogIn />,
      },
      {
        path: 'verify-email',
        element: <Verify />,
      },
      {
        path: 'create-username',
        element: <CreateUsername />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: 'reset-password',
        element: <ResetPassword />,
      },
    ],
  },
];
